import styled from "styled-components"

const Card = styled.div`
  border-radius: 15px;
  padding: 1rem;
  background-color: #ccc;
  font-family: "PT sans", sans-serif;
  max-width: 400px;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
`

const Title = styled.h2`
  text-align: center;
`
const Image = styled.img`
  max-width: 100%;
  border-radius: 10px;
`

const Description = styled.p`
  text-align: center;
`

const ExternalLink = styled.a`
  display: block;
  text-align: center;
  color: #fff;
  background-color: #2196f3;
  text-decoration: none;
  text-transform: uppercase;
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0.5rem 0;
  border-radius: 20px;
`

export { Card, Title, Image, Description, ExternalLink }
